import PropTypes from 'prop-types';

import FilterChipsBar from '#globalComponents/Table/FilterChipsBar';

import { buildLeadFilterChips } from '../../../constants/leadFilters';
import { useTargetingVocabulary } from '../../../models/targeting/queries';

const formatCount = (count) => count.toLocaleString('de-DE');

/**
 * Chip summary of the active lead-table filters. Range filters (min/max pairs) are one chip each,
 * so the leads keep their own chip builder on top of the shared chip bar.
 */
const TableFilterBar = ({ filters, totalCount, unfilteredCount, onRemoveFilter, onClearAll }) => {
	const { data: vocabulary } = useTargetingVocabulary();
	return (
		<FilterChipsBar
			chips={buildLeadFilterChips(filters, vocabulary)}
			resultLabel={
				typeof unfilteredCount === 'number'
					? `${formatCount(totalCount)} von ${formatCount(unfilteredCount)} Firmen`
					: `${formatCount(totalCount)} Firmen`
			}
			onRemove={onRemoveFilter}
			onClearAll={onClearAll}
		/>
	);
};

TableFilterBar.propTypes = {
	filters: PropTypes.object.isRequired,
	totalCount: PropTypes.number.isRequired,
	unfilteredCount: PropTypes.number,
	onRemoveFilter: PropTypes.func.isRequired,
	onClearAll: PropTypes.func.isRequired,
};

export default TableFilterBar;
